export class Random {
  seedLow: number;
  // seedHigh: number;

  constructor(n: number | null) {
    if (n == null) n = 1;
    this.seedLow = n;
    // this.seedHigh = 0;
  }

  setSeed(n: number) {
    this.seedLow = n;
    // this.seedHigh = 0;
  }

  random(max: number) {
    const low = -613566757;
    // var high = 0xa65aec2f;
    const slow = (this.seedLow * low) | 0;
    // var shigh = (this.seedHigh * low + this.seedLow * high) | 0;
    this.seedLow = slow + 1;
    // this.seedHigh = shigh;
    return (this.seedLow >>> 3) % max;
  }

  rand() {
    return this.random(1000) / 1000;
  }
}
